export const isNumber = (value: unknown): value is number => {
  return !isNaN(Number(value)) && isFinite(Number(value)) && value !== null && value !== undefined && value !== '';
};
